import styled from 'styled-components';
import { fontUi } from '../../../theme/typography';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: ${({ theme }) => theme.cardRadius};
  overflow: hidden;
  @media only screen and (max-width: 991px) {
    width: 100%;
    margin: 0 15px;
    max-height: 100%;
    overflow-y: auto;
  }
`;

export const StyledHeader = styled.h2`
  ${fontUi};
  margin: 0;
  padding: 16px 44px 14px 18px;
  background: transparent;
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  color: ${({ theme }) => theme.text};
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-weight: 600;
  position: relative;
`;

export const StyledTeamsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  min-height: 420px;
  @media only screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    min-height: 0;
  }
`;

export const StyledLeagueContainer = styled.div`
  ${fontUi};
  display: flex;
  flex-direction: column;
  min-width: 0;
  max-height: 470px;
  overflow-y: auto;
  background: transparent;
  border: 0;
  border-radius: 0;
  margin: 0;
  &:not(:last-child) {
    border-right: 1px solid ${({ theme }) => theme.borderSubtle};
  }
  @media only screen and (max-width: 991px) {
    max-height: 280px;
    margin: 0;
    &:not(:last-child) {
      border-right: 0;
      border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
    }
  }
`;

export const StyledLeagueHeader = styled.h3`
  ${fontUi};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.textMuted};
  padding: 12px 14px 10px;
  margin: 0;
  position: sticky;
  top: 0;
  background: ${({ theme }) => theme.card};
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  z-index: 1;
`;

export const StyledTeam = styled.div`
  ${fontUi};
  display: flex;
  flex-direction: row;
  gap: 10px;
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.text};
  padding: 0 12px 0 14px;
  justify-content: flex-start;
  align-items: center;
  min-height: 44px;
  height: 44px;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  &:last-child {
    border-bottom: 0;
  }
  svg {
    margin-left: 4px;
    flex-shrink: 0;
  }
`;

export const StyledCrest = styled.img`
  width: 22px;
  height: 22px;
  object-fit: contain;
  flex-shrink: 0;
`;

export const StyledCrestFallback = styled.span`
  ${fontUi};
  width: 22px;
  height: 22px;
  border-radius: 50%;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.hover};
  color: ${({ theme }) => theme.textFaint};
  font-size: 10px;
  font-weight: 700;
`;

export const StyledTeamName = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 4px;
`;
